export default "__VITE_PUBLIC_ASSET__cf474790__"